document.addEventListener('DOMContentLoaded', () => {
  const targetNode = document.querySelector('#MainContent')
  const config = { childList: true, subtree: true }
  const callback = (mutationList, observer) => {
    removeWeight()
  }

  const observer = new MutationObserver(callback)
  observer.observe(targetNode, config)

  function removeWeight () {
    document.querySelectorAll('.css-1aq0to5').forEach(el => {
      if (el.textContent.trim().endsWith('Kg')) {
        el.closest('.css-70qvj9').style.display = 'none'
      }
    })
  }
})
